/**
 * AlphaX Tuning Simulator - Dyno Manager & Charting
 */

let dynoChartInstance = null;
let afrChartInstance = null;
let boostChartInstance = null;
let isDynoPullActive = false;
let dynoPhase = 'idle'; // 'idle', 'hold', 'pull'
let dynoTimer = 0;
let dynoPullTimer = 0;
let dynoStartRpm = 1500;

let rawDynoData = { labels: [], hp: [], tq: [], afr: [], boost: [] };
let dynoAfrGuideline = 13.5;
let dynoPeakHp = 0;
let dynoPeakHpRpm = 0;
let dynoPeakTq = 0;
let dynoPeakTqRpm = 0;
let dynoPeakBoost = 0;

// Reference Storage
let rawRefDynoData = null;
let refPeakHp = 0;
let refPeakHpRpm = 0;
let refPeakTq = 0;
let refPeakTqRpm = 0;

// Apply Rolling Average
function smoothArray(arr, windowSize) {
    if (windowSize <= 0 || arr.length === 0) return [...arr];
    const halfWin = Math.floor(windowSize / 2);
    const n = arr.length;
    const prefix = new Array(n + 1);
    prefix[0] = 0;
    for (let i = 0; i < n; i++) prefix[i + 1] = prefix[i] + arr[i];
    const smoothed = new Array(n);
    for (let i = 0; i < n; i++) {
        const start = Math.max(0, i - halfWin);
        const end = Math.min(n - 1, i + halfWin);
        smoothed[i] = (prefix[end + 1] - prefix[start]) / (end - start + 1);
    }
    return smoothed;
}

// Apply Weather Correction
function getCorrectionFactor() {
    const cfMethodEl = document.getElementById('dyno-cf-method');
    const method = cfMethodEl ? cfMethodEl.value : 'None';
    if (method === 'None') return 1.0;

    const tempF = parseFloat(document.getElementById('sim-ambient-temp')?.value) || 80;
    const hum = parseFloat(document.getElementById('sim-hum')?.value) || 60;
    const baro = parseFloat(document.getElementById('sim-baro')?.value) || 101.3;
    
    const tempC = (tempF - 32) * 5/9;
    const absTempK = tempC + 273.15;
    const eso = 6.112 * Math.exp((17.67 * tempC) / (tempC + 243.5));
    const pv = (hum / 100.0) * eso;
    const pd = baro - (pv / 10.0);
    
    if (method === 'SAE') return 1.180 * ((99.0 / pd) * Math.sqrt(absTempK / 298.0)) - 0.180;
    if (method === 'STD') return (101.3 / pd) * Math.sqrt(absTempK / 288.0);
    return 1.0;
}

function initDynoCharts() {
    const ctxDyno = document.getElementById('dyno-chart').getContext('2d');
    const ctxAfr = document.getElementById('afr-chart').getContext('2d');
    const ctxBoost = document.getElementById('boost-chart').getContext('2d');

    if (typeof Chart === 'undefined') {
        console.error("Chart.js not loaded!");
        return;
    }

    Chart.defaults.color = '#9CA3AF';
    Chart.defaults.font.family = 'sans-serif';

    dynoChartInstance = new Chart(ctxDyno, {
        type: 'line',
        data: { labels: [], datasets: [
            { label: 'Horsepower', borderColor: '#3B82F6', backgroundColor: 'transparent', data: [], tension: 0.4, fill: false, pointRadius: 0, borderWidth: 2 },
            { label: 'Torque', borderColor: '#3B82F6', backgroundColor: 'transparent', data: [], tension: 0.4, borderDash: [5, 5], pointRadius: 0, borderWidth: 2 },
            { label: 'Ref HP', borderColor: '#EF4444', backgroundColor: 'transparent', data: [], tension: 0.4, pointRadius: 0, borderWidth: 2 },
            { label: 'Ref TQ', borderColor: '#EF4444', backgroundColor: 'transparent', data: [], tension: 0.4, borderDash: [5, 5], pointRadius: 0, borderWidth: 2 }
        ]},
        options: {
            responsive: true, maintainAspectRatio: false,
            interaction: { mode: 'index', intersect: false },
            animation: { duration: 0 }, 
            scales: {
                x: { grid: { color: '#374151', drawBorder: false } },
                y: { grid: { color: '#374151', drawBorder: false }, beginAtZero: true }
            },
            plugins: { legend: { labels: { font: { weight: 'bold' } } } }
        }
    });

    afrChartInstance = new Chart(ctxAfr, {
        type: 'line',
        data: { labels: [], datasets: [
            { label: 'AFR', borderColor: '#3B82F6', backgroundColor: 'transparent', data: [], tension: 0.4, pointRadius: 0, borderWidth: 2 },
            { label: `AFR Target (${dynoAfrGuideline})`, borderColor: '#10B981', backgroundColor: 'transparent', data: [], tension: 0, borderDash: [2, 4], pointRadius: 0, borderWidth: 1 },
            { label: 'Ref AFR', borderColor: '#EF4444', backgroundColor: 'transparent', data: [], tension: 0.4, pointRadius: 0, borderWidth: 2 }
        ]},
        options: {
            responsive: true, maintainAspectRatio: false,
            interaction: { mode: 'index', intersect: false },
            animation: { duration: 0 }, 
            scales: {
                x: { grid: { color: '#374151', drawBorder: false }, display: false },
                y: { grid: { color: '#374151', drawBorder: false }, suggestedMin: 10.0, suggestedMax: 16.0 }
            },
            plugins: { legend: { display: false } }
        }
    });

    boostChartInstance = new Chart(ctxBoost, {
        type: 'line',
        data: { labels: [], datasets: [
            { label: 'Boost (psi)', borderColor: '#F97316', backgroundColor: 'transparent', data: [], tension: 0.4, pointRadius: 0, borderWidth: 2 },
            { label: 'Ref Boost', borderColor: '#EF4444', backgroundColor: 'transparent', data: [], tension: 0.4, borderDash: [5, 5], pointRadius: 0, borderWidth: 2 }
        ]},
        options: {
            responsive: true, maintainAspectRatio: false,
            interaction: { mode: 'index', intersect: false },
            animation: { duration: 0 }, 
            scales: {
                x: { grid: { color: '#374151', drawBorder: false }, display: false },
                y: { grid: { color: '#374151', drawBorder: false }, min: 0 }
            },
            plugins: { legend: { display: false } }
        }
    });
}

function replotDyno() {
    if (rawDynoData.labels.length === 0 && !rawRefDynoData) return;
    
    const cf = getCorrectionFactor();
    const smoothFactor = parseInt(document.getElementById('dyno-smoothing').value) || 0;
    const windowSize = smoothFactor > 0 ? (smoothFactor * 2 + 1) : 0;
    
    const hasFI = physics && physics.activeMods.some(m => m.mod_type === "Turbocharger" || m.mod_type === "Supercharger");
    const boostWrapper = document.getElementById('boost-chart-wrapper');
    const boostStatDiv = document.getElementById('dyno-stat-boost-div');
    
    if (hasFI) {
        if (boostWrapper) boostWrapper.style.display = 'flex';
        if (boostStatDiv) boostStatDiv.style.display = 'flex';
    } else {
        if (boostWrapper) boostWrapper.style.display = 'none';
        if (boostStatDiv) boostStatDiv.style.display = 'none';
    }

    let plotLabels = rawDynoData.labels;

    if (rawDynoData.labels.length > 0) {
        const correctedTq = rawDynoData.tq.map(v => v * cf);
        const correctedHp = rawDynoData.hp.map(v => v * cf);
        
        const plotTq = smoothArray(correctedTq, windowSize);
        const plotHp = smoothArray(correctedHp, windowSize);
        const plotAfr = smoothArray(rawDynoData.afr, windowSize);
        const plotBoost = smoothArray(rawDynoData.boost, windowSize);

        dynoPeakHp = plotHp.length ? Math.max(...plotHp) : 0;
        let peakHpIdx = plotHp.indexOf(dynoPeakHp);
        dynoPeakHpRpm = plotLabels[peakHpIdx] || 0;

        dynoPeakTq = plotTq.length ? Math.max(...plotTq) : 0;
        let peakTqIdx = plotTq.indexOf(dynoPeakTq);
        dynoPeakTqRpm = plotLabels[peakTqIdx] || 0;
        
        dynoPeakBoost = plotBoost.length ? Math.max(...plotBoost) : 0;

        dynoChartInstance.data.datasets[0].data = plotHp;
        dynoChartInstance.data.datasets[1].data = plotTq;
        afrChartInstance.data.datasets[0].data = plotAfr;
        afrChartInstance.data.datasets[1].data = plotLabels.map(() => dynoAfrGuideline);
        afrChartInstance.data.datasets[1].label = `AFR Target (${dynoAfrGuideline})`;
        boostChartInstance.data.datasets[0].data = plotBoost;
    }

    if (rawRefDynoData) {
        const refCorrTq = rawRefDynoData.tq.map(v => v * cf);
        const refCorrHp = rawRefDynoData.hp.map(v => v * cf);
        const refPlotTq = smoothArray(refCorrTq, windowSize);
        const refPlotHp = smoothArray(refCorrHp, windowSize);
        const refPlotAfr = smoothArray(rawRefDynoData.afr, windowSize);
        const refPlotBoost = smoothArray(rawRefDynoData.boost, windowSize);
        
        refPeakHp = refPlotHp.length ? Math.max(...refPlotHp) : 0;
        let refHpIdx = refPlotHp.indexOf(refPeakHp);
        refPeakHpRpm = rawRefDynoData.labels[refHpIdx] || 0;

        refPeakTq = refPlotTq.length ? Math.max(...refPlotTq) : 0;
        let refTqIdx = refPlotTq.indexOf(refPeakTq);
        refPeakTqRpm = rawRefDynoData.labels[refTqIdx] || 0;
        
        dynoChartInstance.data.datasets[2].data = refPlotHp;
        dynoChartInstance.data.datasets[3].data = refPlotTq;
        afrChartInstance.data.datasets[2].data = refPlotAfr;
        boostChartInstance.data.datasets[1].data = refPlotBoost;
        
        if (rawRefDynoData.labels.length > plotLabels.length) {
            plotLabels = rawRefDynoData.labels;
        }
        
        document.getElementById('dyno-stat-ref-hp').innerText = `REF HP: ${Math.round(refPeakHp)} @ ${refPeakHpRpm} ${T('rpm', 'RPM')}`;
        document.getElementById('dyno-stat-ref-tq').innerText = `REF TQ: ${Math.round(refPeakTq)} @ ${refPeakTqRpm} ${T('rpm', 'RPM')}`;
    } else {
        dynoChartInstance.data.datasets[2].data = [];
        dynoChartInstance.data.datasets[3].data = [];
        afrChartInstance.data.datasets[2].data = [];
        boostChartInstance.data.datasets[1].data = [];
    }

    dynoChartInstance.data.labels = plotLabels;
    dynoChartInstance.update();

    afrChartInstance.data.labels = plotLabels;
    afrChartInstance.update();
    
    boostChartInstance.data.labels = plotLabels;
    boostChartInstance.update();
    
    if (dynoPhase !== 'pull' && dynoPhase !== 'hold' && rawDynoData.labels.length > 0) {
        document.getElementById('dyno-stat-hp').innerText = `${T('peak_hp', 'PEAK HP:')} ${Math.round(dynoPeakHp)} @ ${dynoPeakHpRpm} ${T('rpm', 'RPM')}`;
        document.getElementById('dyno-stat-tq').innerText = `${T('peak_tq', 'PEAK TQ:')} ${Math.round(dynoPeakTq)} @ ${dynoPeakTqRpm} ${T('rpm', 'RPM')}`;
        if (hasFI) {
            document.getElementById('dyno-stat-boost').innerText = `${T('peak_boost', 'PEAK BOOST:')} ${dynoPeakBoost.toFixed(1)} PSI`;
        }
    }
}

window.replotDyno = replotDyno; 

function runDynoPull() {
    if (isDynoPullActive) {
        abortDynoPull();
        return;
    }

    if (typeof isEngineRunning !== 'undefined' && !isEngineRunning) {
        const pwrBtn = document.getElementById('btn-power');
        if (pwrBtn) pwrBtn.click();
    }

    isDynoPullActive = true;
    dynoPhase = 'hold';
    dynoTimer = 0;
    dynoPullTimer = 0;
    lastLogRpm = dynoStartRpm;
    datalogRows = [];
    if (physics) physics.knockCount = 0;
    
    rawDynoData = { labels: [], hp: [], tq: [], afr: [], boost: [] };
    dynoPeakHp = 0; 
    dynoPeakHpRpm = 0;
    dynoPeakTq = 0;
    dynoPeakTqRpm = 0;
    dynoPeakBoost = 0;

    replotDyno(); 

    const btn = document.getElementById('btn-dyno');
    if (btn) {
        const abortTxt = T('abort_dyno_pull', 'ABORT DYNO PULL');
        btn.innerHTML = `<svg class="w-4 h-4 fill-current" viewBox="0 0 24 24"><path d="M6 6h12v12H6z"/></svg> ${abortTxt}`;
        btn.classList.replace('bg-purple-700', 'bg-red-700');
        btn.classList.replace('hover:bg-purple-600', 'hover:bg-red-600');
    }

    const hpStat = document.getElementById('dyno-stat-hp');
    const tqStat = document.getElementById('dyno-stat-tq');
    if (hpStat) {
        hpStat.innerText = T('holding_rpm', 'HOLDING RPM...');
        hpStat.className = "text-purple-400 font-bold animate-pulse";
    }
    if (tqStat) {
        tqStat.innerText = T('stabilizing', 'STABILIZING...');
        tqStat.className = "text-purple-400 font-bold animate-pulse";
    }
}

function finishDynoPull(error = null) {
    isDynoPullActive = false;
    dynoPhase = 'idle';
    if (typeof isPedalHeldDown !== 'undefined' && !isPedalHeldDown && typeof actualTps !== 'undefined') actualTps = 0;
    
    const btn = document.getElementById('btn-dyno');
    if (btn) {
        btn.innerHTML = `<svg class="w-4 h-4 fill-current" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg> ${T('start_dyno_pull', 'START DYNO PULL')}`;
        btn.classList.replace('bg-red-700', 'bg-purple-700');
        btn.classList.replace('hover:bg-red-600', 'hover:bg-purple-600');
    }
    
    const refBtn = document.getElementById('btn-set-ref');
    if (refBtn) refBtn.disabled = false;

    const hpStat = document.getElementById('dyno-stat-hp');
    const tqStat = document.getElementById('dyno-stat-tq');
    if (hpStat) hpStat.innerText = `${T('peak_hp', 'PEAK HP:')} ${Math.round(dynoPeakHp)} @ ${dynoPeakHpRpm} ${T('rpm', 'RPM')}`;
    if (tqStat) tqStat.innerText = `${T('peak_tq', 'PEAK TQ:')} ${Math.round(dynoPeakTq)} @ ${dynoPeakTqRpm} ${T('rpm', 'RPM')}`;
    
    const hasFI = physics && physics.activeMods.some(m => m.mod_type === "Turbocharger" || m.mod_type === "Supercharger");
    if (hasFI) {
        const boostStat = document.getElementById('dyno-stat-boost');
        if (boostStat) boostStat.innerText = `${T('peak_boost', 'PEAK BOOST:')} ${dynoPeakBoost.toFixed(1)} PSI`;
    }

    if (error) {
        if (hpStat) hpStat.className = "text-red-500 font-bold";
        if (tqStat) tqStat.className = "text-red-500 font-bold";
    } else {
        if (hpStat) hpStat.className = "text-blue-400 font-bold";
        if (tqStat) tqStat.className = "text-blue-400 font-bold";
    }
    
    // Export the generated Datalog
    if (typeof exportDatalog === 'function') exportDatalog('Dyno');
}

function abortDynoPull() {
    finishDynoPull("ABORTED");
}

function setReferencePull() {
    if (isDynoPullActive || rawDynoData.labels.length === 0) {
        alert("Please complete a valid dyno pull first.");
        return;
    }
    
    rawRefDynoData = {
        labels: [...rawDynoData.labels],
        hp: [...rawDynoData.hp],
        tq: [...rawDynoData.tq],
        afr: [...rawDynoData.afr],
        boost: [...rawDynoData.boost]
    };
    refPeakHp = dynoPeakHp;
    refPeakHpRpm = dynoPeakHpRpm;
    refPeakTq = dynoPeakTq;
    refPeakTqRpm = dynoPeakTqRpm;
    
    replotDyno();

    const refDiv = document.getElementById('dyno-ref-div');
    if (refDiv) refDiv.classList.remove('hidden');

    const btn = document.getElementById('btn-set-ref');
    if (btn) {
        btn.innerText = "REFERENCE SAVED";
        btn.classList.replace('text-gray-300', 'text-green-400');
        setTimeout(() => {
            btn.innerText = "SET AS REFERENCE";
            btn.classList.replace('text-green-400', 'text-gray-300');
        }, 2000);
    }
}
